export default {
	twitter: 'https://twitter.com/digsconnect',
	facebook: 'https://www.facebook.com/digsconnect',
	instagram: 'https://www.instagram.com/digsconnect',
	blog: 'https://blog.digsconnect.com',
	youtube: 'https://www.youtube.com/channel/UCFLv6RRYZOzbbd2uwupUsKQ',
};
